import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { HideIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const restrictedAsset = /*#__PURE__*/_jsx(IconHolder, {
  color: "icon-primary-disabled",
  marginInlineEnd: "200",
  icon: HideIcon
});
export const wrapWithRestrictedAssetTooltip = content => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.restrictedAsset.noViewOrEditAccess"
    }),
    children: /*#__PURE__*/_jsx(Fragment, {
      children: content
    })
  });
};